<template>
  <div class="bgf4">
    <div class="box bgfff" style="display:block;margin:20px auto;padding:20px;">
      <div class="export">
        <h3 class="h3">专家介绍</h3>
        <img src="../../images/line_zjjs.png">
        <div class="info">
          <img :src="image+data.expertimage" class="exportimg fleft">
          <h5>{{datajj}}</h5>
          <div v-html="desc" >
          </div>
        </div>
        <div class="info" style="margin-top:40px">
          <span class="blueblock"></span>
          <span class="bt">主要研究方向</span>
          <p class="margin">{{data.research}}</p>
          <p></p>
        </div>
        <div class="info" style="margin-top:40px">
          <span class="blueblock"></span>
          <span class="bt">擅长领域</span>
          <p class="margin">{{data.expertfield}}</p>
        </div>
      </div>

    </div>
  </div>
</template>



<script>
import http from '../../js/axios'

export default {
  name: 'App',
  data(){
    return{
      data:[],
      desc:'',
      datajj:'',
      image:''
    }
  },
  computed:{

  },
  created(){
    this.queryByID(this.$route.query.id)
    this.image = http.imageURL
  },
  mounted () {

  },
  watch: {

  },
  methods: {
    queryByID(id){
      http.get('/queryByIdzjk',{params:{id:id}}
      ).then((res) => {
          this.data = res.data.result
          this.desc = this.data.profile
          let s = []
          if(this.data.expertname!=null){
            s.push(this.data.expertname)
          }
          if(this.data.expertunit!=null){
            s.push(this.data.expertunit)
          }
          if(this.data.profession!=null){
            s.push(this.data.profession)
          }
          for(var i=0;i<s.length;i++){
            if (i < s.length - 1) {
              this.datajj += s[i] + ",";
            } else {
              this.datajj += s[i];
            }
          }
      })
    },
  },
}
</script>


<style scoped>
  @import "../../config/AquaticExpertsDetial.css"
</style>







// WEBPACK FOOTER //
// src/views/aquaticexperts/AquaticExpertsDetial.vue